import React from 'react';

const PageHeaderWithTabs = ({
  title,
  description,
  tabs = [],
  activeTab,
  onTabChange,
  searchTerm = '',
  onSearchChange,
  onSearchSubmit,
  searchPlaceholder = 'Search...',
  showFilter = false,
  onFilterClick,
  className = ''
}) => {
  return (
    <div className={`space-y-6 ${className}`}>
      {/* Page Title and Actions */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-[28px] font-semibold text-[#0a1f17] font-inter tracking-[-0.56px] leading-[1.4] mb-2">
            {title}
          </h1>
          {description && (
            <p className="text-[14px] text-[#73827c]">
              {description}
            </p>
          )}
        </div>
        
        <div className="flex items-center gap-3">
          {showFilter && (
            <button 
              onClick={onFilterClick}
              className="flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-gray-50 rounded-lg border border-gray-300 transition-colors"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M2 5.33333H14" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M2 10.6667H14" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M4.66667 2V14" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
              Filter
            </button>
          )}
          <div className="relative">
            <input
              type="text"
              placeholder={searchPlaceholder}
              value={searchTerm}
              onChange={(e) => onSearchChange(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' && onSearchSubmit) {
                  e.preventDefault();
                  onSearchSubmit(e);
                }
              }}
              className="w-64 pl-10 pr-4 py-2 border border-gray-300 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-emerald-400 focus:border-transparent"
            />
            <svg className="absolute left-3 top-2.5 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
        </div>
      </div>

      {/* Tabs Section */}
      {tabs.length > 0 && (
        <div className="bg-white rounded-xl shadow-sm border border-gray-200">
          <div className="px-6 py-4">
            <div className="flex items-center gap-2 w-full">
              {tabs.map((tab) => (
                <button
                  key={tab.name || tab.value || tab.id}
                  onClick={() => onTabChange(tab.name || tab.value || tab.id)}
                  className={`flex-1 px-6 py-3 text-sm font-medium transition-all rounded-lg flex items-center justify-center gap-2 ${
                    activeTab === (tab.name || tab.value || tab.id)
                      ? 'bg-emerald-50 text-emerald-600'
                      : 'text-gray-600 hover:bg-gray-50'
                  }`}
                >
                  {(tab.showRedDot === true) && (
                    <span className="w-2 h-2 bg-red-500 rounded-full flex-shrink-0" title="Awaiting review" />
                  )}
                  {tab.label || tab.name}
                  {tab.count !== undefined && (
                    <span className={`ml-0.5 px-2.5 py-0.5 rounded-full text-xs font-semibold ${
                      activeTab === (tab.name || tab.value || tab.id)
                        ? 'bg-emerald-500 text-white'
                        : 'bg-gray-200 text-gray-600'
                    }`}>
                      {tab.count}
                    </span>
                  )}
                </button>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PageHeaderWithTabs;
